import HeaderImage from "../../assets/images/main_header.jpg";
import {Breadcrumb, Button, Image, Table} from "antd";
import {Link} from "react-router-dom";
import {FilePdfOutlined} from "@ant-design/icons";

import Image1 from "../../assets/images/factory4.jpg";
import Image2 from "../../assets/images/factory3.jpg";
import TY081130_001File from "../../assets/files/TY 08.11.30-001.pdf";


const MDP2 = () => {

    const images = [
        { id: 1, src: Image1, alt: "МТП-1 вид 1" },
        { id: 2, src: Image2, alt: "МТП-1 вид 2" },
    ];

    const tableData = [
        { key: "1", number: 1, indicator: "Массовая доля влаги", value: "не более 0,2%" },
        {
            key: "2",
            number: 2,
            indicator: "Суммарная доля углекислого кальция и углекислого магния в пересчете на углекислый кальций",
            value: "не менее 96%"
        },
        {
            key: "3",
            number: 3, indicator: "Массовая доля веществ, не растворимых в HC1",
            value: "Не более 2%"
        },
        { key: "4", number: 4, indicator: "Массовая доля полуторных оксидов железа и аллюминия ", value: "не более 0,7%" },
        { key: "5", number: 5, indicator: "Массовая доля оксида железа (III)", value: "не более 0,25%" },
        { key: "6", number: 6, indicator: "Массовая доля марганца", value: "не более 0,02%" },
        { key: "7", number: 7, indicator: "Массовая доля меди", value: "не более 0,001%" },
        { key: "8", number: 8, indicator: "Массовая доля железа, извлекаемого магнитом", value: "не более 0,03%" },
        { key: "9", number: 9, indicator: "Коэффициент отражения", value: "не менее 85%" },
        {
            key: "10",
            number: 10,
            indicator: "Допустиомое значение удельной эффективной активности природных радионуклидов (радий - 226, торий - 232)",
            value: "не боле 370 Бк/кг"
        },
        { key: "11", number: 11, indicator: "Остаток на сите с сеткой № 014", value: "не более 1%" },
    ];

    const tableColumns = [
        {
            title: "№",
            dataIndex: "number",
            key: "number",
            width: 80,
            align: "center",
        },
        {
            title: "Показатели",
            dataIndex: "indicator",
            key: "indicator",
            width: "65%",
        },
        {
            title: "Численные значения, нормированные по ТУ",
            dataIndex: "value",
            key: "value",
        },
    ];

    return(
        <div className={"product-container"}>
            <div className={"product-container-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className={"product-header"}>
                <h1>МДП-2</h1>
                <Breadcrumb className="product-header-breadcrumb"
                            items={[
                                {
                                    title: <Link to="/">Главная страница</Link>
                                },
                                {
                                    title: <Link to="/productions">Продукция</Link>
                                },
                                {
                                    title: <span>МДП-2</span>,
                                },
                            ]}
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"product-content"}>
                <div className={"product-content-image-column"}>
                    <Button
                        type="primary"
                        icon={<FilePdfOutlined/>}
                        size="large"
                        onClick={() => window.open(TY081130_001File, "_blank", "noopener,noreferrer")}
                        className="pp-pdf-button"
                    >
                        Посмотреть ТУ
                    </Button>

                    <div className="images-grid">
                        {images.map((image) => (
                            <div className="image-wrapper" key={image.id}>
                                <Image
                                    src={image.src}
                                    alt={image.alt}
                                    className="pp-image"
                                    preview={{
                                        src: image.src,
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                </div>


                <div className={"product-content-text-column"}>
                    <div className={"product-content-text-column"}>
                        <div className={"product-content-description"}>
                            <h2>Описание продукта</h2>
                            <p>
                                <strong>МДП-2</strong> — это природный сухомолотый мел, получаемый высушиванием и
                                измельчением рыхлой известняковой породы. Продукт имеет порошкообразную форму, низкую
                                абразивность и применяется в качестве эффективного минерального наполнителя
                            </p>

                            <h3>Основные характеристики:</h3>
                            <ul>

                                <li> Порошкообразная форма с малой абразивностью </li>

                                <li> Химическая нейтральность и нетоксичность </li>
                                <li>
                                    Класс опасности: 4-й (малоопасное вещество), пожаро- и взрывобезопасен
                                </li>
                            </ul>

                            <h3>Области применения:</h3>
                            <ul>
                                <li>
                                    Производство лакокрасочных материалов (в качестве наполнителя)
                                </li>
                                <li>
                                    Изготовление строительных материалов (сухие строительные смеси, штукатурки, шпаклевки)
                                </li>
                                <li>
                                    Целлюлозно-бумажная промышленность
                                </li>
                                <li>
                                    Производство пластмасс, резинотехнических и полимерных изделий
                                </li>
                                <li>
                                    Текстильная и химическая промышленность
                                </li>
                            </ul>

                            <h3>Преимущества:</h3>
                            <ul>
                                <li>
                                    Функциональность: выступает как наполнитель, разбавитель и стабилизатор, способствуя
                                    упрочнению материала
                                </li>
                                <li>
                                    Экономическая эффективность: снижает себестоимость готовой продукции, частично
                                    замещая более дорогие компоненты
                                </li>
                                <li>
                                    Экологическая и производственная безопасность: является природным, нетоксичным
                                    материалом
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MDP2;